<template>
    <ai-tree-list-edit-wrapper
        ref="treeListRef"
        :meta="meta"
        :args="args"
        :to-remove-toolbar-items-names="['moveSave', 'moveTo', 'choice', 'edit', 'cut', 'put']"
        @tree-list-edit-wrapper-mounted="onTreeListMounted"
    />
</template>
<script setup>
import { ref } from 'vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { setTabReadyToSaveValue } from '@/layouts/main-layout/components/navigation-bars-data';

const treeListRef = ref();
const gridInstance = ref();

const onTreeListMounted = async () => {
    gridInstance.value = {
        refresh: treeListRef.value.ref.setDataSource,
        userData: treeListRef.value.setUserDataFromCacheOrApi,
        userSettings: () => {},
    };
    setActiveViewInfo(gridInstance.value);

    await setViewData();

    setTabReadyToSaveValue(true);
};

const meta = {
    keyExpr: 'kod_group_cust',
    title: 'Группы потребителей',
    columns: [
        {
            name: 'kod_group_cust',
            caption: 'kod_group_cust',
            dataField: 'kod_group_cust',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 1,
            visible: false,
            dataType: 'number',
        },
        {
            name: 'num_gr',
            caption: 'Номер',
            dataField: 'num_gr',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 2,
            visible: true,
            dataType: 'number',
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 3,
            visible: true,
        },
        {
            name: 'fin_name',
            caption: 'Наименование для ФО',
            dataField: 'fin_name',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 10,
            visible: true,
        },
        {
            name: 'status',
            caption: 'Статус',
            dataField: 'status',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name_status',
            },
            component: {
                name: 'group-cust-status-lookup',
                id: 'status',
                text: 'name_status',
            },
            width: 50,
            index: 4,
            visible: true,
        },
        {
            name: 'tep_el',
            caption: 'Тип',
            dataField: 'tep_el',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name_tep_el',
            },
            component: {
                name: 'group-cust-tep-el-lookup',
                id: 'tep_el',
                text: 'name_tep_el',
            },
            width: 250,
            index: 5,
            visible: true,
        },
        {
            name: 'kod_gr_parent',
            caption: 'kod_gr_parent',
            dataField: 'kod_gr_parent',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 6,
            visible: false,
            dataType: 'number',
        },
        {
            name: 'prim',
            caption: 'Примечание',
            dataField: 'prim',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 7,
            visible: true,
        },
        {
            name: 'num_cust',
            caption: 'num_cust',
            dataField: 'num_cust',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 8,
            visible: false,
            dataType: 'number',
        },
    ],
    api: {
        select: 'nsi./nsi/view-ks-group-cust/select/get',
        save: 'nsi./nsi/view-ks-group-cust/save/set',
    },
    viewId: 'view-ks-group-cust',
    parentIdExpr: 'kod_gr_parent',
};
const args = {};
</script>

<script>
export default {
    name: 'ks-group-cust-view',
};
</script>

<style scoped></style>
